import type { Staff } from "@/lib/authv2/store";
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

export function canWritePromos(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.PromoWrite);
}

/**
 * Ai VÀO được trang Ưu đãi.
 *
 * Từ 23/08/2026 có hai mức: quản trị/giám đốc vừa xem vừa sửa (promo.write),
 * trưởng Sale và trưởng Marketing chỉ xem số liệu hiệu quả (promo.read) —
 * đây là chỗ họ đọc "Tổng giảm" và các bảng phân tích. Ai có quyền ghi thì
 * đương nhiên đọc được, nên vẫn hỏi cả hai.
 */
export function canReadPromos(staff: Staff | null): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.PromoRead) || hasPermission(ACTION.PromoWrite);
}
